<template>
    <div>
        <el-row class="tac">
            <el-col :span="6">
                <h5>我的消息</h5>
                <el-menu
                        default-active="2"
                        class="el-menu-vertical-demo">
                    <router-link :to="'/sysNotice'">
                        <el-menu-item index="1" >
                            <!--<i class="el-icon-menu"></i>-->
                                <span slot="title">系统通知</span>
                        </el-menu-item>
                    </router-link>
                    <router-link :to="'/reply'">
                        <el-menu-item index="2">
                            <!--<i class="el-icon-setting"></i>-->
                                <span slot="title">回复我的</span>
                        </el-menu-item>
                    </router-link>
                </el-menu>
            </el-col>

            <el-col :span="18">
                <h5>内容</h5>
                <router-view class="right-content"></router-view>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Message",
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            }
        }
    }
</script>

<style scoped>
    .right-content{
        margin-left: 30px;
    }
</style>
